const PRIORITY_COLORS: Record<string, string> = {
  urgent: "bg-red-500",
  standard: "bg-amber-500",
};

const PRIORITY_LABELS: Record<string, string> = {
  urgent: "Urgent",
  standard: "Standard",
};

const RECURRENCE_LABELS: Record<string, [string, string]> = {
  daily: ["Daily", "days"],
  weekly: ["Weekly", "weeks"],
  monthly: ["Monthly", "months"],
  yearly: ["Yearly", "years"],
};

export function getPriorityColor(priority: string): string {
  return PRIORITY_COLORS[priority] || "bg-gray-400";
}

export function getPriorityLabel(priority: string): string {
  return PRIORITY_LABELS[priority] || priority;
}

export function getRecurrenceLabel(
  recurrenceType: string | null | undefined,
  interval: number = 1
): string | null {
  if (!recurrenceType || recurrenceType === "none") return null;

  const labels = RECURRENCE_LABELS[recurrenceType];
  if (!labels) return null;

  const [singular, plural] = labels;
  return interval === 1 ? singular : `Every ${interval} ${plural}`;
}

export function getOverdueDays(dueDate: string): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const due = new Date(dueDate + "T00:00:00");
  return Math.round((today.getTime() - due.getTime()) / 86400000);
}
